export enum BUILDER_TYPES {
  sphere = 'sphere',
  box = 'box',
}
